export const projectService = [

    {
        id: 77,
        img: 'https://i.ibb.co/VvCkwp3/bacola.png',
        name: 'Grocery Shop',
        description: "It's a Single vendor grocery Web application. where any user can buy their favorite product. an user can search a product also select product form category.Admin can Handle full aplicaiton access  like upload, delete and update product. Handle Delivery Management and User Management",
        github: 'https://github.com/zamanrabeen671/GOGO-Travel-client',
        liveSite: 'https://klbtheme.com/bacola/',
        tools: ['React.js', 'Node.js', 'Express.js', 'MongoDB','Mongoose', 'Firebase', 'MUI', 'Stripe.js'],
    },
    {
        id: 1,
        img: 'https://i.ibb.co/jGjYBsh/imgbb-Bando.png',
        name: 'ban.do',
        description: "It's a Multivendor E-Commerce Web application. where any user can buy their favorite product. an user can search a product also select product form category.Admin can Handle full aplicaiton access and a seller can sell his product and get update about his product",
        github: 'https://github.com/zamanrabeen671/GOGO-Travel-client',
        liveSite: 'https://gogo-travels.web.app/',
        tools: ['React.js', 'Node.js', 'Express.js', 'MongoDB','Mongoose', 'Firebase', 'Tailwind','Material-UI', 'Stripe.js'],
    },
    {
        id: 2,
        img: 'https://i.ibb.co/7rS07zg/Screenshot-2021-05-01-133006.jpg',
        name: 'GOGO Travel',
        description: 'A Single page web app where client can book their events and checkout their information. Admin can add a new Events and can admin another people',
        github: 'https://github.com/zamanrabeen671/GOGO-Travel-client',
        liveSite: 'https://gogo-travels.web.app/',
        tools: ['React.js', 'Node.js', 'Express.js', 'MongoDB', 'Firebase', 'Bootstrap', 'Stripe.js'],
    },
    {
        id: 6,
        img: 'https://i.ibb.co/2ts9xj4/Screenshot-2021-05-02-005850.jpg',
        name: 'Hungry Monster',
        description: 'An Online Food Restora App where your a search a meal and select your favorite food. We serve best fresh food',
        github:'https://github.com/zamanrabeen671/Hungry-Monster',
        liveSite: 'https://zamanrabeen671.github.io/Hungry-Monster/',
        tools: ['JavaScript', 'MealDB API', 'HTML', 'CSS', 'Bootstrap'],
    }
]
